import React, { useEffect, useState } from 'react';
import apiClient from '@/services/apiClient';

/** Required Pricing Channel filter for the Combo V2 planners (default TN). MRPs come from this channel's "New" rates only. */
export const PricingChannelSelect = ({ value, onChange }) => {
  const [chans, setChans] = useState([value]);
  useEffect(() => {
    apiClient.get('/combo-v2/plans/lookup/pricing-channels').then((r) => setChans(r.data.channels || [value])).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <label className="text-sm font-medium text-stone-700" htmlFor="pricing-channel-select">Pricing Channel <span className="text-rose-600">*</span></label>
      <select id="pricing-channel-select" required value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-1 block h-10 w-48 rounded-md border border-input bg-white px-3 text-sm" data-testid="pricing-channel-select">
        {chans.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <p className="mt-1 text-xs text-stone-500">Customer MRPs come from this channel's New rates only.</p>
    </div>
  );
};

export default PricingChannelSelect;
